import { Injectable } from '@angular/core';
import { TranslateService } from '../../../api/translate.service';

import { 
  fieldAddressLine1Col,
  fieldAddressLine2Col,
  fieldApprovedByCol,
  fieldBuildingNameCol,
  fieldChecklistQuestionCol,
  fieldChecklistQuestionNoteCol,
  fieldConfidentialityStatusCol,
  fieldCountryCol,
  fieldCreatedByCol,
  fieldCurrencyCol,
  fieldCustomerNameCol,
  fieldDateCol,
  fieldDistrictCol,
  fieldIdCol,
  fieldInvoiceIdCol,
  fieldInvoiceTypeCol,
  fieldLocalityCol,
  fieldMiqIdCol,
  fieldOppNumberCol,
  fieldOpportunityCol,
  fieldOpportunityInstallmentCol,
  fieldOpportunitySourceCol,
  fieldPostcodeCol,
  fieldPrimaryEmployeeFunctionalUnitCol,
  fieldPrimaryEmployeeFunctionalUnitIdCol,
  fieldPrimaryEmployeeIdCol,
  fieldPrimaryEmployeeManagingOfficeIdCol,
  fieldPrimaryEmployeeNameCol,
  fieldRegionCol,
  fieldRepresentedPartyCol,
  fieldSubmittedByCol,
  fieldSuburbCol,
  fieldTeamCol,
  fieldTransactionTypeCol,
} from '../../../utils/ag-grid/column-defs';
import { ColDef } from 'ag-grid-community';

@Injectable({
  providedIn: 'root'
})
export class DealFileChecklistSingaporeReportService {

  constructor(private translateService: TranslateService) { }
  getHeaders(settings: { middle: any, left: any, right: any }) {
    return [
      {
        header: this.translateService.getTranslation('FINISHLINE_ID'),
        key: 'finishline_id',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('INVOICE_ID'),
        key: 'invoice_id',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('TRANSACTION_TYPE'),
        key: 'transaction_type',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('INVOICE_DT'),
        key: 'invoice_date',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('INVOICE_TYPE'),
        key: 'invoice_type',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('TEAM_ID'),
        key: 'team',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('CURRENCY'),
        key: 'currency',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('OPPORTUNITY_NO'),
        key: 'opportunity_number',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('OPPORTUNITY_ID'),
        key: 'opportunity',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('OPPORTUNITY_INSTALLMENT_ID'),
        key: 'opportunity_installment_id',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('OPPORTUNITY_SOURCE'),
        key: 'opportunity_source',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('REPRESENTED_PARTY'),
        key: 'repped_customer',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('BILL_TO_CUST'),
        key: 'bill_to_customer_name',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('MIQ_PROPERTY_ID'),
        key: 'miq_property_id',
        width: 20,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('BUILDING_NAME'),
        key: 'building_name',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('ADDRESS_LINE1'),
        key: 'address_line1',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('ADDRESS_LINE2'),
        key: 'address_line2',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('POSTAL_CODE'),
        key: 'postal_code',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('SUBURB'),
        key: 'suburb',
        width: 16,
        style: { ...settings.left },
      },
      {
        header: this.translateService.getTranslation('DISTRICT'),
        key: 'district',
        width: 16,
        style: { ...settings.left },
      },
      {
        header: this.translateService.getTranslation('LOCALITY'),
        key: 'locality',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('REGION'),
        key: 'region',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('COUNTRY'),
        key: 'country',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('PRIMARY_EMPLOYEE_ID'),
        key: 'primary_employee_id',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('PRIMARY_EMPLOYEE_NAME'),
        key: 'primary_employee_name',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('PRIMARY_EMPLOYEE_FU_ID'),
        key: 'primary_employee_functional_unit_id',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('PRIMARY_EMPLOYEE_FU_DESC'),
        key: 'primary_employee_functional_unit',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('PRIMARY_EMPLOYEE_MO_ID'),
        key: 'primary_employee_managing_office_id',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('CONFLICT_OF_INTEREST').toUpperCase(),
        key: 'is_there_a_conflict_of_interest',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('DETAIL_NOTE'),
        key: 'is_there_a_conflict_of_interest_note',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('INTERMEDIARY_BETWEEN_CLIENT_AND_GOVERNMENT_ENTITY').toUpperCase(),
        key: 'did_cbre_act_as_intermediary',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('GOVERNMENT_ENTITY').toUpperCase(),
        key: 'government_entity_checklist',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('DETAIL_NOTE'),
        key: 'government_entity_checklist_note',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('SIGNED_AGENCY_AGREEMENT').toUpperCase(),
        key: 'signed_agency_agreement',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('DETAIL_NOTE'),
        key: 'signed_agency_agreement_note',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('EXECUTED_LEASE_AGREEMENT').toUpperCase(),
        key: 'contract_executed_lease_or_signed_agreement',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('DETAIL_NOTE'),
        key: 'contract_executed_lease_or_signed_agreement_note',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('SUPPORTING_CORRESPONDENCE').toUpperCase(),
        key: 'confirmation_the_deal_is_unconditional_settled',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('DETAIL_NOTE'),
        key: 'confirmation_the_deal_is_unconditional_settled_note',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('FEE_CALCULATION_APPROVAL').toUpperCase(),
        key: 'fee_calculation_approval',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('DETAIL_NOTE'),
        key: 'fee_calculation_approval_note',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('SGP_SUPPORTING_DOCUMENTS_UPLOAD').toUpperCase(),
        key: 'other_supporting_documents',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('DETAIL_NOTE'),
        key: 'other_supporting_documents_note',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('CONJUNCTIONAL_AGREEMENT_UPLOADED').toUpperCase(),
        key: 'conjunctional_agreement',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('DETAIL_NOTE'),
        key: 'conjunctional_agreement_note',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('CREATED_BY'),
        key: 'created_by',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('SUBMITTED_BY'),
        key: 'submitted_by',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('APPROVED_BY'),
        key: 'approved_by',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('CONFIDENTIALITY_STATUS'),
        key: 'confidentiality_status',
        width: 30,
        style: { ...settings.middle },
      },
    ];
  }

  getDataSourceSettings(): ColDef[] {
    return [
      {
        ...fieldIdCol,
        field: 'finishline_id',
        headerName: this.translateService.getTranslation('FINISHLINE_ID'),
      }, 
      {
        ...fieldInvoiceIdCol,
        field: 'invoice_id',
        headerName: this.translateService.getTranslation('INVOICE_ID'),
        cellRenderer: null,
      },
      {
        ...fieldTransactionTypeCol,
        headerName: this.translateService.getTranslation('TRANSACTION_TYPE'),
      },
      {
        ...fieldDateCol,
        field: 'invoice_date',
        headerName: this.translateService.getTranslation('INVOICE_DT'),
        cellRenderer: null,
      },
      {
        ...fieldInvoiceTypeCol,
        headerName: this.translateService.getTranslation('INVOICE_TYPE'),
      },
      {
        ...fieldTeamCol,
        headerName: this.translateService.getTranslation('TEAM_ID'),
      },
      {
        ...fieldCurrencyCol,
        headerName: this.translateService.getTranslation('CURRENCY'),
      },
      {
        ...fieldOppNumberCol,
        headerName: this.translateService.getTranslation('OPPORTUNITY_NO'),
      },
      {
        ...fieldOpportunityCol,
        headerName: this.translateService.getTranslation('OPPORTUNITY_ID'),
      },
      {
        ...fieldOpportunityInstallmentCol,
        headerName: this.translateService.getTranslation('OPPORTUNITY_INSTALLMENT_ID'),
      },
      {
        ...fieldOpportunitySourceCol,
        headerName: this.translateService.getTranslation('OPPORTUNITY_SOURCE'),
      },
      {
        ...fieldRepresentedPartyCol,
        field: 'repped_customer',
        headerName: this.translateService.getTranslation('REPRESENTED_PARTY'),
      },
      {
        ...fieldCustomerNameCol,
        field: 'bill_to_customer_name',
        headerName: this.translateService.getTranslation('BILL_TO_CUST'),
      },
      {
        ...fieldMiqIdCol,
        headerName: this.translateService.getTranslation('MIQ_PROPERTY_ID'),
      },
      {
        ...fieldBuildingNameCol,
        headerName: this.translateService.getTranslation('BUILDING_NAME'),
      },
      {
        ...fieldAddressLine1Col,
        headerName: this.translateService.getTranslation('ADDRESS_LINE1'),
      },
      {
        ...fieldAddressLine2Col,
        headerName: this.translateService.getTranslation('ADDRESS_LINE2'),
      },
      {
        ...fieldPostcodeCol,
        headerName: this.translateService.getTranslation('POSTAL_CODE'),
      },
      {
        ...fieldSuburbCol,
        headerName: this.translateService.getTranslation('SUBURB'),
      },
      {
        ...fieldDistrictCol,
        headerName: this.translateService.getTranslation('DISTRICT'),
      },
      {
        ...fieldLocalityCol,
        headerName: this.translateService.getTranslation('LOCALITY'),
      },
      {
        ...fieldRegionCol,
        headerName: this.translateService.getTranslation('REGION'),
      },
      {
        ...fieldCountryCol,
        headerName: this.translateService.getTranslation('COUNTRY'),
      },      
      {
        ...fieldPrimaryEmployeeIdCol,
        headerName: this.translateService.getTranslation('PRIMARY_EMPLOYEE_ID'),
      },
      {
        ...fieldPrimaryEmployeeNameCol,
        headerName: this.translateService.getTranslation('PRIMARY_EMPLOYEE_NAME'),
      },
      {
        ...fieldPrimaryEmployeeFunctionalUnitIdCol,
        headerName: this.translateService.getTranslation('PRIMARY_EMPLOYEE_FU_ID'),
      },
      {
        ...fieldPrimaryEmployeeFunctionalUnitCol,
        headerName: this.translateService.getTranslation('PRIMARY_EMPLOYEE_FU_DESC'),
      },
      {
        ...fieldPrimaryEmployeeManagingOfficeIdCol,
        headerName: this.translateService.getTranslation('PRIMARY_EMPLOYEE_MO_ID'),
      },       
      {
        ...fieldChecklistQuestionCol,
        field: 'is_there_a_conflict_of_interest',
        headerName: this.translateService.getTranslation('CONFLICT_OF_INTEREST').toUpperCase(),
      },
      {
        ...fieldChecklistQuestionNoteCol,
        field: 'is_there_a_conflict_of_interest_note',
        headerName: this.translateService.getTranslation('DETAIL_NOTE'),
      },      
      {
        ...fieldChecklistQuestionCol,
        field: 'did_cbre_act_as_intermediary',
        headerName: this.translateService.getTranslation('INTERMEDIARY_BETWEEN_CLIENT_AND_GOVERNMENT_ENTITY').toUpperCase(),
      },
      {
        ...fieldChecklistQuestionCol,
        field: 'government_entity_checklist',
        headerName: this.translateService.getTranslation('GOVERNMENT_ENTITY').toUpperCase(),
      },
      {
        ...fieldChecklistQuestionNoteCol,
        field: 'government_entity_checklist_note',
        headerName: this.translateService.getTranslation('DETAIL_NOTE'),
      },      
      {
        ...fieldChecklistQuestionCol,
        field: 'signed_agency_agreement',
        headerName: this.translateService.getTranslation('SIGNED_AGENCY_AGREEMENT').toUpperCase(),
      },
      {
        ...fieldChecklistQuestionNoteCol,
        field: 'signed_agency_agreement_note',
        headerName: this.translateService.getTranslation('DETAIL_NOTE'),
      },      
      {
        ...fieldChecklistQuestionCol,
        field: 'contract_executed_lease_or_signed_agreement',
        headerName: this.translateService.getTranslation('EXECUTED_LEASE_AGREEMENT').toUpperCase(),
      },
      {
        ...fieldChecklistQuestionNoteCol,
        field: 'contract_executed_lease_or_signed_agreement_note',
        headerName: this.translateService.getTranslation('DETAIL_NOTE'),
      },      
      {
        ...fieldChecklistQuestionCol,
        field: 'confirmation_the_deal_is_unconditional_settled',
        headerName: this.translateService.getTranslation('SUPPORTING_CORRESPONDENCE').toUpperCase(),
      },
      {
        ...fieldChecklistQuestionNoteCol,
        field: 'confirmation_the_deal_is_unconditional_settled_note',
        headerName: this.translateService.getTranslation('DETAIL_NOTE'),
      },      
      {
        ...fieldChecklistQuestionCol,
        field: 'fee_calculation_approval',
        headerName: this.translateService.getTranslation('FEE_CALCULATION_APPROVAL').toUpperCase(),
      },
      {
        ...fieldChecklistQuestionNoteCol,
        field: 'fee_calculation_approval_note',
        headerName: this.translateService.getTranslation('DETAIL_NOTE'),
      },      
      {
        ...fieldChecklistQuestionCol,
        field: 'other_supporting_documents',
        headerName: this.translateService.getTranslation('SUPPORTING_DOCUMENTS_UPLOAD').toUpperCase(),
      },    
      {
        ...fieldCreatedByCol,
        headerName: this.translateService.getTranslation('CREATED_BY'),
      },            
      {
        ...fieldSubmittedByCol,
        headerName: this.translateService.getTranslation('SUBMITTED_BY'),
      },
      {
        ...fieldApprovedByCol,
        headerName: this.translateService.getTranslation('APPROVED_BY'),
      },
      {
        ...fieldConfidentialityStatusCol,
        headerName: this.translateService.getTranslation('CONFIDENTIALITY_STATUS'),
      }      
    ];
  }
}
